var React = require('react');

function Copy (props) {
    return React.createElement("svg",props,React.createElement("g",{"className":"fill-none stroke-foreground"},[React.createElement("path",{"strokeLinejoin":"round","strokeMiterlimit":"10","d":"M17.8,21.7H8.5c-0.6,0-1-0.5-1-1V8.5\n\tc0-0.6,0.4-1,1-1h9.3c0.5,0,1,0.4,1,1v12.2C18.8,21.2,18.4,21.7,17.8,21.7z","key":0}),React.createElement("path",{"strokeLinejoin":"round","strokeMiterlimit":"10","d":"M3.5,18.2V4.4c0-0.5,0.4-0.9,0.9-0.9h11.8","key":1})]));
}

Copy.defaultProps = {"version":"1.1","width":"24px","height":"24px","viewBox":"0 0 24 24","style":{"enableBackground":"new 0 0 24 24"},"xmlSpace":"preserve"};

module.exports = Copy;

Copy.default = Copy;
